<!-- <ckeditor #myckeditor class="customEditor" [config]="ckEditorConfig" debounce="100" [(ngModel)]="currentBody" name="currentBody" [ngClass]='hideToolbar ? "no-toolbar": "has-toolbar"' (change)="onEditorChange($event)"></ckeditor> -->

<div class="click-wrapper" (click)="onEditorChange()">
  <ckeditor #myckeditor class="customEditor" [config]="ckEditorConfig" debounce="100" [(ngModel)]="currentBody" name="currentBody" [ngClass]='hideToolbar ? "no-toolbar": "has-toolbar"' 
  (blur)="onEditorChange()"></ckeditor>
</div>